import React, { Component } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Select from '@mui/material/Select';
import Input from '@mui/material/Input';
import FormGroup from '@mui/material/FormGroup';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import AdministratorsApi from '../../../api/administrators';
import AccountsApi from '../../../api/accounts';
import { connect } from 'react-redux';
import { showError } from '../../../actions/uiActions';
import MultiSelect from '../../MultiSelect';
import { Chip } from '@mui/material';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import WysiwygEditor from '../../WysiwygEditor';

const EVENTS = [
    "Coaching Call",
    "Borrower Onboarding",
    "Quarterly Update",
    "General Inquiry"
];
class CreateUserNote extends Component {
    state = {
        noteState: EditorState.createEmpty(),
        note: '',
        admins: [],
        notifications: [],
        busy: false,
        event: "",
        isCallToServicer: false,
        isCallToClient: false,
        isEditing: false
    }

    handleFaqInputState = (noteState) => {
        const noteContentBlock = htmlToDraft(noteState);
        const faqContentState = ContentState.createFromBlockArray(
            noteContentBlock.contentBlocks
        );
        const noteEditorState = EditorState.createWithContent(faqContentState);
        this.setState({ noteState: noteEditorState })
    };

    componentDidMount() {
        if (this.props.editingNote) {
            const {note, event, isCallToClient, isCallToServicer} = this.props.editingNote
            this.setState({
                isEditing: true,
                note,
                event,
                isCallToClient,
                isCallToServicer
            })
            this.handleFaqInputState(note)
        }
        AdministratorsApi.getList().then(admins => this.setState({ admins }, error => { })).catch(error => { })
    }
    getRoleName = (role) => {
        switch (role) {
            case "coach":
                return "Student Loans Coach";
            case "sales":
                return "Sales Representative";
            case "admin":
                return "Administrator";
            default:
                return role;
        }
    }
    handleSelection = (event) => {
        this.setState({ notifications: event.target.value })
    }
    save = () => {
        if (this.state.note.length < 5) {
            return this.props.showError("Each note must have a minimum of 5 characters.");
        }
        if (!this.state.event) {
            return this.props.showError("You must select an event");
        }
        const noteId = this.props.editingNote ? this.props.editingNote.id : ""
        this.setState({ busy: true }, () => AccountsApi.addNote(this.props.account._id, {
            user: this.props.account.name || `${this.props.account.firstname} ${this.props.account.lastname}`,
            note: this.state.note,
            notifications: this.state.admins.filter(admin => this.state.notifications.includes(admin._id)), 
            event: this.state.event,
            isCallToClient: this.state.isCallToClient,
            isCallToServicer: this.state.isCallToServicer
        }, noteId).then(note => {
            this.props.onNoteAdded({ ...note, read: [this.props.user.id] }, this.state.isEditing);
            this.props.onClose();
        }).catch(error => this.setState({ busy: false }, this.props.showError)))
    }

    hasUserInput = () => {
        // Check if the user has entered any data in the form
        return this.state.note.length > 0 || 
               this.state.event !== "" || 
               this.state.notifications.length > 0 ||
               this.state.isCallToServicer || 
               this.state.isCallToClient;
    }

    handleClose = (e, reason) => {
        // If user has entered data, only allow closing via Cancel button
        if (reason === 'backdropClick' && this.hasUserInput()) {
            e.stopPropagation();
            return;
        }
        this.props.onClose();
    }

    render() {
        return <Dialog 
            disableBackdropClick={this.hasUserInput()} 
            disableEscapeKeyDown={this.hasUserInput()} 
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description" 
            open={true} 
            maxWidth="sm" 
            fullWidth={true}
        >
            <DialogTitle id="alert-dialog-title">{this.state.isEditing ? "Edit note": "Add note"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="form-group nice">
                        <label>Note:</label>
                        <WysiwygEditor
                            className="form-control"
                            name="note"
                            onChange={(e) => this.setState({ note: e.target.value })}
                            disabled={this.state.busy}
                            value={this.state.note}
                        />
                    </div>
                    <div className="form-group nice">
                        <label>What Event</label>
                        <Select
                            value={this.state.event}
                            onChange={e => this.setState({ event: e.target.value })}
                            id="event-select"
                            className="full-width"
                        >
                            <MenuItem value="">--Select Event--</MenuItem>
                            {
                                EVENTS.map((each, index) => <MenuItem key={index} value={each}>{each}</MenuItem>)
                            }
                        </Select>
                    </div>
                    <div>
                        <label>Actions Taken (optional)</label>
                        <FormGroup row>
                            <FormControlLabel
                                control={
                                    <Checkbox checked={this.state.isCallToServicer} onChange={(e) => this.setState({ isCallToServicer: !this.state.isCallToServicer })} value="isCallToServicer" />
                                }
                                label="Call to Servicer"
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox checked={this.state.isCallToClient} onChange={(e) => this.setState({ isCallToClient: !this.state.isCallToClient })} value="isCallToServicer" />
                                }
                                label="Call to Client"
                            />
                        </FormGroup>
                    </div>
                    <div className="form-group nice">
                        <label>Who do you want to notify?</label>
                        <MultiSelect
                            disabled={this.state.busy}
                            variant="outlined"
                            multiple
                            value={this.state.notifications}
                            onChange={this.handleSelection}
                            input={<Input />}
                            className="full-width"
                            renderValue={selected => {

                                const admins = this.state.admins.filter(admin => selected.includes(admin._id));
                                // console.log(admins,selected)
                                return <div> {admins.map(value => (
                                    <Chip className="chip" key={value._id} label={`${value.name} (${this.getRoleName(value.role)})`} />
                                ))}
                                </div>
                            }}
                        >
                            {this.state.admins.map((admin, index) => <MenuItem key={`admin-${index}`} value={admin._id}>
                                {admin.name} ({this.getRoleName(admin.role)})
            </MenuItem>)}
                        </MultiSelect>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    disabled={this.state.busy} variant="outlined" onClick={this.save} color="primary">
                    {this.state.isEditing ? "Edit Note" : "Save Note"}
          </Button>
                <Button
                    disabled={this.state.busy} onClick={this.props.onClose} color="primary">
                    Cancel
          </Button>
            </DialogActions>
        </Dialog>;
    }
}
const mapStateToProps = state => {
    return {
        user: state.auth.account
    }
};
export default connect(mapStateToProps, { showError })(CreateUserNote);